import React from 'react';
import T from 'prop-types';
import { Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

import ButtonRouter from '../buttonRouter';
import SignupButton from '../signupButton';
import PayButton from '../payButton';

const CheckoutButtonProfessional = ({
  isAuthenticated,
  isUserAdvanced,
  isUserProfessional,
  plan,
  size,
  showUpdateSubscriptionModal,
  uuid,
}) => {
  if (!isAuthenticated) {
    return <SignupButton block size={size} type="primary" />;
  }

  if (isUserProfessional) {
    return (
      <ButtonRouter block icon={<CheckOutlined />} size={size} to="/settings/billing">
        Current Plan
      </ButtonRouter>
    );
  }

  if (isUserAdvanced) {
    return (
      <Button block onClick={showUpdateSubscriptionModal} size={size} type="primary">
        Choose Plan
      </Button>
    );
  }

  return (
    <PayButton plan={plan} size={size} uuid={uuid}>
      Upgrade
    </PayButton>
  );
};

CheckoutButtonProfessional.propTypes = {
  showUpdateSubscriptionModal: T.func.isRequired,

  isAuthenticated: T.bool.isRequired,
  isUserAdvanced: T.bool.isRequired,
  isUserProfessional: T.bool.isRequired,
  plan: T.string.isRequired,
  uuid: T.string.isRequired,

  size: T.string,
};

CheckoutButtonProfessional.defaultProps = {
  size: 'large',
};

export default CheckoutButtonProfessional;
